export default __webpack_public_path__ + "2711730fe9e3e937c2c71d2791f30bcc.png";